/**
 * Get the value of a cookie in the browser.
 *
 * This does not work on the server.
 */
export const getCookie = (name: string): string | undefined => {
	const cookie = document.cookie.match(
		`(^|[^;]+)\\s*${name}\\s*=\\s*([^;]+)`
	);
	return cookie ? cookie.pop() : '';
};

/**
 * Set a cookie in the browser, expiring after the given number of days.
 *
 * This does not work on the server.
 */
export const setCookie = (name: string, value: string, days: number): void => {
	const maxAgeSeconds = days * 24 * 60 * 60;
	document.cookie = `${name}=${value};path=/;max-age=${maxAgeSeconds}`;
};
